import { Components, Theme } from '@mui/material/styles';

export const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.MuiFormHelperText-root': {
        marginLeft: 0,
        marginTop: '10px',
        ...theme.typography.body2,
      },
    }),
  },
};
